import { Box } from '@mui/material';
import PropTypes from 'prop-types';

import { Copyright } from '../../Copyright';
import { ContactsBPC } from './Contacts';
import { FooterStyled } from './FooterBPC.styles';

export const FooterBPC = ({ id, className }) => (
  <Box>
    <FooterStyled id={id ?? 'footer'} className={className ?? null}>
      <ContactsBPC />
    </FooterStyled>

    <Copyright />
  </Box>
);

FooterBPC.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
};
